import { Component, OnInit } from '@angular/core'
import {
    FormGroup,
    UntypedFormBuilder,
    Validators,
    UntypedFormControl,
} from '@angular/forms'
import { MessageService } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { validateAllFormFields } from '../../../../formUtils'
import { ReportsService } from '../../../../api/services'
import { ReportingSettings } from '../../../../api/models'
import { ReportingSetting } from '../../../../api/models/reporting-setting'

@Component({
    selector: 'app-add',
    templateUrl: './addReports.component.html',
    styleUrls: ['./addReports.component.css'],
})
export class AddReportsComponent implements OnInit {
    addreport
    errorValidationSummary: string = ''
    reportCategoryId: number
    reportCategoryName: string
    ShowErrorSummary: boolean = false
    reportDsnList: ReportingSetting[];
    
    constructor(
        private fb: UntypedFormBuilder,
        private messageService: MessageService,
        private reportservice: ReportsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) { }

    ngOnInit() {
        debugger

        this.activatedRoute.queryParams.subscribe((params) => {
            let data = params
            this.reportCategoryId = data.rcategory_id
            this.reportCategoryName = data.rcategory_name
        });

        this.addreport = this.fb.group({
            reportCategoryName: [this.reportCategoryName, Validators.required],
            reportDisplayName: ['', Validators.required],
            reportFileName: ['', Validators.required],
            reportShortNote: ['', Validators.required],
            patientFlag: new UntypedFormControl(false, []),
            reportDsnName: ['', Validators.required],
        });

        this.loadReportDsnList();
    }

    loadReportDsnList() {
        this.reportservice.reportsGetDsnList()
            .subscribe((result) => {
                this.reportDsnList = result;
            });
    }

    saveReport() {
        validateAllFormFields(this.addreport)
        if (this.addreport.invalid) {
            return
        }
        debugger

        const reportDsn = this.addreport.get('reportDsnName').value as ReportingSetting;
        this.addreport.patchValue({
            reportDsnName: reportDsn.dsn,
        });

        this.reportservice
            .reportsAddReport({
                body: this.addreport.value,
                reportCategoryId: this.reportCategoryId,
            })
            .subscribe(
                (val) => {
                    if (val) {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            summary: 'Confirmation',
                            detail: `Report  saved successfully `,
                            life: 5000,
                        })
                    }
                    this.router.navigate(['administration/manage-reports'])
                },
                (err) => {
                    this.messageService.add({
                        key: 'alertToast',
                        severity: 'error',
                        summary: 'ERROR',
                        detail: `This report display name  is already taken.Please choose another report display name .! `,
                        life: 5000,
                    })

                    //console.log(err.error);
                },
            )
    }
}
